import React, { useContext, useEffect, useState } from 'react';
import {
  Drawer,
  Button,
  Table,
  Space,
  Form,
  Input,
  Select,
  message,
  Popconfirm,
  Collapse,
} from 'antd';
import { GlobalContext } from '../../../../context/globalContext';
import { LoginContext } from '../../../../context/loginContext';

const { Panel } = Collapse;

const CCategoriasEmpresa = () => {
  const { categorias, refreshCategorias } = useContext(GlobalContext);
  const { user } = useContext(LoginContext);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [form] = Form.useForm();
  const [editing, setEditing] = useState(null);

  const [nivel1, setNivel1] = useState(null);
  const [nivel2, setNivel2] = useState(null);
  const [nivel3, setNivel3] = useState(null);

  const openDrawer = () => {
    setDrawerOpen(true);
    resetForm();
  };

  const resetForm = () => {
    form.resetFields();
    setEditing(null);
    setNivel1(null);
    setNivel2(null);
    setNivel3(null);
  };

  const getOptions = padreId =>
    categorias
      .filter(c => c.cat_padre_id === padreId)
      .map(c => ({ label: c.cat_nombre, value: c.cat_id }));

  const onFinish = async values => {
    try {
      const method = editing ? 'PUT' : 'POST';
      const endpoint = editing
        ? `${process.env.REACT_APP_API_URL}/categorias/${editing}`
        : `${process.env.REACT_APP_API_URL}/categorias`;

      const res = await fetch(endpoint, {
        method,
        headers: {
          'Authorization': `Bearer ${user.token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });

      if (!res.ok) throw new Error();
      message.success(editing ? 'Categoría actualizada' : 'Categoría creada');
      refreshCategorias();
      resetForm();
      setDrawerOpen(false);
    } catch {
      message.error('Error al guardar la categoría');
    }
  };

  const handleEdit = cat => {
    setEditing(cat.cat_id);
    form.setFieldsValue(cat);
    preselectLevels(cat.cat_padre_id);
    setDrawerOpen(true);
  };

  const handleDelete = async id => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/categorias/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${user.token}` },
      });
      if (!res.ok) throw new Error();
      message.success('Categoría eliminada');
      refreshCategorias();
    } catch {
      message.error('Error al eliminar la categoría');
    }
  };

  const preselectLevels = catPadreId => {
    if (!catPadreId) return;
    const padre = categorias.find(c => c.cat_id === catPadreId);
    if (!padre) return;

    const nivel3Cat = padre;
    const nivel2Cat = categorias.find(c => c.cat_id === nivel3Cat.cat_padre_id);
    const nivel1Cat = nivel2Cat ? categorias.find(c => c.cat_id === nivel2Cat.cat_padre_id) : null;

    setNivel1(nivel1Cat?.cat_id || (nivel2Cat ? nivel2Cat.cat_padre_id : nivel3Cat.cat_padre_id));
    setNivel2(nivel2Cat?.cat_id || nivel3Cat.cat_padre_id);
    setNivel3(nivel3Cat.cat_id);
  };

  const renderCategoriasRecursivo = (padreId = null) => {
    const hijos = categorias.filter(c => c.cat_padre_id === padreId);
    if (hijos.length === 0) return null;

    return (
      <Collapse bordered={false} defaultActiveKey={['0']}>
        {hijos.map(hijo => (
          <Panel
            key={hijo.cat_id}
            header={
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>{hijo.cat_nombre}</span>
                <Popconfirm
                  title="¿Eliminar categoría?"
                  onConfirm={() => handleDelete(hijo.cat_id)}
                >
                  <Button size="small" danger type="link">
                    Eliminar
                  </Button>
                </Popconfirm>
              </div>
            }

          >
            {renderCategoriasRecursivo(hijo.cat_id)}
          </Panel>
        ))}
      </Collapse>
    );
  };

  return (
    <>
      <Button type="primary" onClick={openDrawer} style={{ marginBottom: '1rem' }}>
        Nueva Categoría
      </Button>

      {renderCategoriasRecursivo()}

      <Drawer
        title={editing ? 'Editar Categoría' : 'Nueva Categoría'}
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={500}
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Form.Item
            label="Nombre"
            name="cat_nombre"
            rules={[{ required: true, message: 'Ingrese el nombre' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Categoría padre">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Select
                placeholder="Nivel 1"
                value={nivel1}
                options={getOptions(null)}
                onChange={id => {
                  setNivel1(id);
                  setNivel2(null);
                  setNivel3(null);
                  form.setFieldValue('cat_padre_id', id);
                }}
                allowClear
              />
              {nivel1 && (
                <Select
                  placeholder="Nivel 2"
                  value={nivel2}
                  options={getOptions(nivel1)}
                  onChange={id => {
                    setNivel2(id);
                    setNivel3(null);
                    form.setFieldValue('cat_padre_id', id);
                  }}
                  allowClear
                />
              )}
              {nivel2 && (
                <Select
                  placeholder="Nivel 3"
                  value={nivel3}
                  options={getOptions(nivel2)}
                  onChange={id => {
                    setNivel3(id);
                    form.setFieldValue('cat_padre_id', id);
                  }}
                  allowClear
                />
              )}
            </div>
          </Form.Item>

          <Form.Item name="cat_padre_id" hidden>
            <Input />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Guardar
            </Button>
            <Button onClick={resetForm} style={{ marginLeft: 8 }}>
              Limpiar
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default CCategoriasEmpresa;